import { HQ } from "../sportConfig";
import React, { useEffect, useRef, useState } from "react";
import "./PullToRefresh.css";

const TRIGGER_DISTANCE = 70;
const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

const PullToRefresh = () => {
  const [enabled] = useState(isStandalone);
  const [pull, setPull] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const pullRef = useRef(0);
  const gesture = useRef({ tracking: false, x: 0, y: 0 });

  useEffect(() => {
    if (!enabled) return undefined;
    document.body.classList.add("standalone-app");

    const reset = () => {
      gesture.current.tracking = false;
      pullRef.current = 0;
      setPull(0);
    };

    const onTouchStart = (event) => {
      if (refreshing || document.body.style.position === "fixed" || window.scrollY > 0 || event.touches.length !== 1) return;
      const touch = event.touches[0];
      gesture.current = { tracking: true, x: touch.clientX, y: touch.clientY };
    };

    const onTouchMove = (event) => {
      if (!gesture.current.tracking || event.touches.length !== 1) return;
      const touch = event.touches[0];
      const deltaY = touch.clientY - gesture.current.y;
      const deltaX = Math.abs(touch.clientX - gesture.current.x);
      if (deltaY <= 0 || deltaX > deltaY) {
        reset();
        return;
      }
      event.preventDefault();
      const distance = Math.min(100, deltaY * 0.45);
      pullRef.current = distance;
      setPull(distance);
    };

    const onTouchEnd = () => {
      if (!gesture.current.tracking) return;
      gesture.current.tracking = false;
      if (pullRef.current >= TRIGGER_DISTANCE) {
        setRefreshing(true);
        pullRef.current = 62;
        setPull(62);
        window.sessionStorage.setItem(`${HQ.storagePrefix}-force-refresh`, "1");
        window.setTimeout(() => window.location.reload(), 450);
      } else {
        pullRef.current = 0;
        setPull(0);
      }
    };

    window.addEventListener("touchstart", onTouchStart, { passive: true });
    window.addEventListener("touchmove", onTouchMove, { passive: false });
    window.addEventListener("touchend", onTouchEnd, { passive: true });
    window.addEventListener("touchcancel", reset, { passive: true });
    return () => {
      document.body.classList.remove("standalone-app");
      window.removeEventListener("touchstart", onTouchStart);
      window.removeEventListener("touchmove", onTouchMove);
      window.removeEventListener("touchend", onTouchEnd);
      window.removeEventListener("touchcancel", reset);
    };
  }, [enabled, refreshing]);

  if (!enabled) return null;
  const ready = pull >= TRIGGER_DISTANCE;
  const progress = Math.min(1, pull / TRIGGER_DISTANCE);

  return (
    <div
      className={`pull-refresh${pull > 0 ? " pull-refresh--visible" : ""}${ready ? " pull-refresh--ready" : ""}${refreshing ? " pull-refresh--refreshing" : ""}`}
      style={{ transform: `translate3d(-50%, ${pull - 58}px, 0)`, "--pull-progress": progress }}
      aria-live="polite"
    >
      <span className="pull-refresh__symbol" aria-hidden="true">{refreshing ? "" : "↓"}</span>
      <span>{refreshing ? "Uppdaterar…" : ready ? "Släpp för att uppdatera" : "Dra för att uppdatera"}</span>
    </div>
  );
};

export default PullToRefresh;
